import React, { Component } from "react";
import { connect } from "react-redux";
import EmptyCart from "./EmptyCart";
import CartItemFeatured from "./CartItemFeatured";
import standardTrip from "../../Images/Trips/nicole-harrington-483074-unsplash.jpg";
import tripImageOption1 from "../../Images/Trips/cassie-matias-202984-unsplash.jpg";
import tripImageOption2 from "../../Images/Trips/dominik-jirovsky-749482-unsplash.jpg";
import tripImageOption3 from "../../Images/Trips/laura-lefurgey-smith-106965-unsplash.jpg";
import { moreTrips } from "../Store/Actions/EuropeActions";
import { asiaMoreTrips } from "../Store/Actions/AsiaActions";
import { americaMoreTrips } from "../Store/Actions/AmericaActions";

class MoreTours extends Component {
  render() {
    const europeInCart = this.props.europeData
      .map(item => (item.inCart ? item : "fail"))
      .filter(checkNull);
    const asiaInCart = this.props.asiaData
      .map(item => (item.inCart ? item : "fail"))
      .filter(checkNull);
    const americaInCart = this.props.americaData
      .map(item => (item.inCart ? item : "fail"))
      .filter(checkNull);
    function checkNull(arr) {
      return arr !== "fail";
    }
    const itemsInCart = europeInCart.concat(asiaInCart, americaInCart);
    const dispayItems = itemsInCart.map((item, i, arr) =>
      arr.length - 1 === i ? (
        <CartItemFeatured
          key={item.id}
          item={item}
          standardOptionValue={item.tripStandard}
          standardImg={standardTrip}
          option1={tripImageOption1}
          Option1Value={item.tripOption1}
          Option1Description="Additional trip 1"
          option2={tripImageOption2}
          Option2Value={item.tripOption2}
          Option2Description="Additional trip 2"
          option3={tripImageOption3}
          Option3Value={item.tripOption3}
          Option3Description="Additional trip 3"
          choosenValue={item.choosenTripOption}
          handleChange={
            item.continent === "europe"
              ? this.props.moreTrips
              : item.continent === "asia"
              ? this.props.asiaMoreTrips
              : this.props.americaMoreTrips
          }
          line={false}
        />
      ) : (
        <CartItemFeatured
          key={item.id}
          item={item}
          standardOptionValue={item.tripStandard}
          standardImg={standardTrip}
          option1={tripImageOption1}
          Option1Value={item.tripOption1}
          Option1Description="Additional trip 1"
          option2={tripImageOption2}
          Option2Value={item.tripOption2}
          Option2Description="Additional trip 2"
          option3={tripImageOption3}
          Option3Value={item.tripOption3}
          Option3Description="Additional trip 3"
          choosenValue={item.choosenTripOption}
          handleChange={
            item.continent === "europe"
              ? this.props.moreTrips
              : item.continent === "asia"
              ? this.props.asiaMoreTrips
              : this.props.americaMoreTrips
          }
          line={true}
        />
      )
    );
    console.log(itemsInCart);
    return (
      <React.Fragment>
        <div className="tours-parallax parallax d-flex justify-content-center align-items-center">
          <h1 className="main-photo-text">More tours</h1>
        </div>
        <div className="container mt-4">
          <div className="card">
            <div className="card-body">
              {itemsInCart.length === 0 ? (
                <EmptyCart />
              ) : (
                <h2 className="text-center card-title">Items in cart</h2>
              )}
              {dispayItems}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  europeData: state.europe,
  asiaData: state.asia,
  americaData: state.america
});

const mapDispatchToProps = dispatch => {
  return {
    moreTrips: (id, data) => {
      dispatch(moreTrips(id, data));
    },
    asiaMoreTrips: (id, data) => {
      dispatch(asiaMoreTrips(id, data));
    },
    americaMoreTrips: (id, data) => {
      dispatch(americaMoreTrips(id, data));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MoreTours);
